module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("68SU1"))).then(() => module.bundle.root('d0iPb'));